import { useAsyncValue, useNavigate, useSubmit } from 'react-router-dom';
import React, { useCallback, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

// Components
import AddVehicleForm from '../../../../../components/forms/AddVehicleForm';

// Utils
import { createFormDataFromValues } from '../../../../../utils/forms';

// Constants
import { formVehicleNaming } from '../../../../../components/forms/AddVehicleForm/constants';

// Styles
import { Container } from './styles';

// Types
import {
  type AddBasicInfoAccidentLoaderWithDynamicTypes,
  type AddBasicInfoAccidentWithDynamicKeys,
} from './types';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

export default function EditVehiclePage(): JSX.Element {
  const navigate = useNavigate();
  const loaderData =
    useAsyncValue() as AddBasicInfoAccidentLoaderWithDynamicTypes;
  const dispatch = useDispatch();

  const submit = useSubmit();

  const handleReturn = useCallback(() => {
    navigate(-1);
  }, []);

  useLayoutEffect(() => {
    if (!loaderData) {
      // Sin el paso 1 de ESTA Order el loader devuelve `null` (Task 7):
      // rebote al paso 1 con `replace`, para que «atrás» no vuelva a caer
      // aquí (revisión de la Task 12a).
      navigate('..', { replace: true });
    } else {
      dispatch(
        roidOTSelected(
          'edit-accident',
          loaderData.orderParentRoid,
          loaderData.orderParentId
        )
      );
    }
  }, []);

  const onFormSubmit = async (values: AddBasicInfoAccidentWithDynamicKeys) => {
    const formData = createFormDataFromValues({
      ...values,
      vehicles: JSON.stringify(values.vehicles),
    });

    submit(formData, {
      action: '.',
      method: 'POST',
    });
  };

  return (
    <Container>
      <AddVehicleForm
        onFormSubmit={onFormSubmit}
        namingPersistForm={formVehicleNaming.EDIT_VEHICLE_FORM}
        onReturn={handleReturn}
        initialData={loaderData}
      />
    </Container>
  );
}
